export const clone = (param) => JSON.parse(JSON.stringify(param));
